/* Steel Pack: when a shopper picks an option value that doesn't exist with their other selections
   (e.g. a colour that isn't made in the selected size), switch the other option to the nearest
   available value before the theme loads the variant, so a price and Add to cart always show. */
(function () {
  if (window.__spVariantFallback) return;
  window.__spVariantFallback = true;

  var cache = {};
  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function load(handle) {
    if (!handle || cache[handle]) return;
    cache[handle] = 'loading';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[handle] = p.variants || []; })
      .catch(function () { delete cache[handle]; });
  }
  function find(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function preload() {
    document.querySelectorAll('variant-picker').forEach(function (p) { load(handleFromUrl(p.dataset.productUrl)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preload); else preload();

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || t.type !== 'radio') return;
    var picker = t.closest('variant-picker');
    if (!picker) return;
    var variants = cache[handleFromUrl(picker.dataset.productUrl)];
    if (!Array.isArray(variants)) return;
    var sets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    if (sets.length < 2) return;
    var values = sets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
    if (values.indexOf(null) > -1 || find(variants, values)) return;
    var changed = sets.findIndex(function (f) { return f.contains(t); });
    // Try the other options, last one first (usually Size), keeping the shopper's new choice.
    for (var k = sets.length - 1; k >= 0; k--) {
      if (k === changed) continue;
      var inputs = Array.prototype.slice.call(sets[k].querySelectorAll('input'));
      var current = inputs.findIndex(function (i) { return i.checked; });
      // nearest neighbour first, available variants preferred
      var order = inputs.map(function (i, idx) { return { i: i, d: Math.abs(idx - current), idx: idx }; })
        .sort(function (a, b) { return a.d - b.d || a.idx - b.idx; });
      var fallback = null;
      for (var n = 0; n < order.length; n++) {
        var cand = values.slice();
        cand[k] = order[n].i.value;
        var v = find(variants, cand);
        if (v && v.available) { fallback = order[n].i; break; }
        if (v && !fallback) fallback = order[n].i;
      }
      if (fallback) {
        if (typeof picker.updateSelectedOption === 'function') picker.updateSelectedOption(fallback);
        else fallback.checked = true;
        return;
      }
    }
  }, true);
})();
